import React, { Component } from "react";
import Topbar from "./../Topbar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import KpiSummaryScenarioMetaInfo from "./KpiSummaryScenarioMetaInfo";
import { fetchIndividualKPIEvaluationStatus } from "./../../../actions/KpiSummaryDashboardEnhanced/KpiSummaryLevelThreeAction";
import PropTypes from "prop-types";
import KpiSummaryLevelThreeKpiRssComponent from "./KpiSummaryLevelThreeKpiRssComponent";
import KpiSummaryLevelThreeKpiLevel1Component from "./KpiSummaryLevelThreeKpiLevel1Component";
import KpiSummaryLevelThreeKpiLevel0Component from "./KpiSummaryLevelThreeKpiLevel0Component";

class KpiSummaryLevelThree extends Component {
    componentDidMount() {
        // console.log("topology id", this.props.location.data);
        if (this.props.location.data != undefined) {
            const payload = this.props.location.data.cadId;
            this.props.getIndividualKPIEvaluationStatus(payload);
        }
    }

    render() {
        return (
            <div>
                <Topbar />
                <div className="page-wrapper">
                    <Breadcrumb>
                        <Breadcrumb.Item href="">
                            <Link to="/navigate_new">Home</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <Link to="/welcomeautomatekpi">Automate KPI</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <Link to="/welcomeautomatekpi/landingkpidashboard">KPI Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <Link to="/kpidashboardcloseloop">Close Loop</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <Link to="/close_loop/individual/kpi/dashboard">AD Analytics</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="" active>
                            {" "}
                            KPI Level Scenario Status
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="container-fluid" style={{ marginLeft: "0%" }}>
                        <div
                            className="page-content fade-in-up"
                            style={{ margin: "2% 3%", backgroundColor: "white" }}
                        >
                            <div className="row">
                                <div className="col-lg-12">
                                    <div
                                        className="card"
                                        style={{ backgroundColor: "white", border: "white" }}
                                    >
                                        <div
                                            className="card-body"
                                            style={{ padding: "0%", paddingTop: "0%" }}
                                        >
                                            <div className="tab-content">
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="pill-1-3"
                                                >
                                                    <div
                                                        style={{
                                                            backgroundColor: "#757AF7",
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            fontSize: "1.2rem",
                                                            borderRadius: "0%",
                                                            padding: "1%",
                                                        }}
                                                    >
                                                        KPI level scenario status
                                                    </div>
                                                    <div style={{ paddingTop: "1rem" }}>
                                                        <KpiSummaryScenarioMetaInfo />
                                                    </div>
                                                    <div>
                                                        <KpiSummaryLevelThreeKpiLevel0Component
                                                            loading={this.props.loading}
                                                            error={this.props.error}
                                                            kpiStatusData={this.props.kpiStatusData}
                                                        />
                                                        <KpiSummaryLevelThreeKpiLevel1Component
                                                            loading={this.props.loading}
                                                            error={this.props.error}
                                                            kpiStatusData={this.props.kpiStatusData}
                                                        />
                                                        <KpiSummaryLevelThreeKpiRssComponent
                                                            loading={this.props.loading}
                                                            error={this.props.error}
                                                            kpiStatusData={this.props.kpiStatusData}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.KpiSummaryLevelThreeData.loading,
    kpiStatusData: state.KpiSummaryLevelThreeData.kpiStatusData,
    error: state.KpiSummaryLevelThreeData.error,
});

const mapDispatchToProps = (dispatch) => ({
    getIndividualKPIEvaluationStatus: (payload) =>
        dispatch(fetchIndividualKPIEvaluationStatus(payload)),
});

KpiSummaryLevelThree.propTypes = {
    location: PropTypes.object,
    getIndividualKPIEvaluationStatus: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.string,
    kpiStatusData: PropTypes.object,
};

KpiSummaryLevelThree.defaultProps = {
    location: {},
    loading: false,
    error: "",
    kpiStatusData: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(KpiSummaryLevelThree);
